import { Validator } from '@vista-digital/validator';
import { ZoomControllerZoomButtonsPosition, zoomControllerZoomButtonsPositionValidator } from '../../../../../subcomponents/zoom-controller/types/zoom-buttons-position';
export const defaultOccSeatingNavigationConfig = {
    showPanButtons: false,
    showZoomButtons: true,
    zoomButtonsPosition: ZoomControllerZoomButtonsPosition.Auto
};
export const occSeatingNavigationConfigValidator = Validator.object({
    showPanButtons: Validator.boolean(),
    showZoomButtons: Validator.boolean(),
    zoomButtonsPosition: zoomControllerZoomButtonsPositionValidator
});
//# sourceMappingURL=navigation.js.map